import getConfig from '../config';

const internetConfig = getConfig({
	solrRoot: 'https://search.cdc.gov/srch/',
	webHost: 'https://www.cdc.gov',
	actionHost: 'https://search.cdc.gov',

	// Prop for Using Deep Linking in Search
	deepLink: true,

	// size limits for output
	limits: {
		title: 150,
		description: 230,
		relatedTitle:  36,
		totalRelated: 125,
	},

	// description weighting rules
	descriptions: {
		// when set, we ignore descriptions with this or more number of capitalized words
		maxCapitalized: 16,
	},

	// Spellcheck config
	spellchecker: {
		enabled: true,
		totalThreshhold: 0, // How few results before we always provide correction
		wordFrequencyFloor: 15, // How few occurences of a single word before it's considered wrongly spelled?
		correctionDistance: 1, // How many more times hits should a suggestion get before it becomes a correction
		suggestionDistance: 1, // How many more times hits should a suggestion get before it becomes a correction
		totalSuggestions: 3,
		collationsSort: false, // logic tweak: sort the collations that come in, or use as is
		wordLimit: 4,
		wordsLimit: 10,
	},
	typeahead: {
		enabled: true,
		charsMin: 2, // min chars before performing typeahead search
		charsMax: 0, // max chars for performing typeahead search
		max: 5, // number of config results to return
	},
	bestBets: {
		enabled: true,
		limit: 3,
	},

	// display related links?
	topTerms: 'https://www.cdc.gov/search/topterms.txt',
	ciosURL: 'https://www.cdc.gov/search/search-orgs.json', // location for CIO orgs data
	ciosBoost: 2, // location for CIO orgs data
	json_ld: true, // don't render widgets yet
	facetLimit: 2000,
	suggested: {
		enabled: true,
		url: 'https://www.cdc.gov/config/tax/terms-options-t001.json'
	}
});

export default internetConfig;
